{
  "title": "Modules",
  "installed_count": "{{count}} installed",
  "loading": "Loading modules…",
  "empty": "No modules found.",
  "status": {
    "loaded": "Loaded",
    "error": "Error",
    "available": "Available"
  },
  "update": {
    "available": "Update available",
    "badge": "v{{from}} → v{{to}}",
    "current": "Up to date",
    "count_one": "{{count}} update",
    "count_other": "{{count}} updates",
    "all": "Update all",
    "all_running": "Updating ({{done}}/{{total}})…"
  },
  "actions": {
    "install": "Install",
    "installing": "Installing…",
    "update": "Update",
    "updating": "Updating…",
    "uninstall": "Uninstall",
    "uninstalling": "Uninstalling…"
  },
  "log": {
    "waiting": "Waiting for output…",
    "success": "Completed successfully",
    "failed": "Failed"
  }
}
